module.exports = __webpack_public_path__ + "img/ill_6.78771c82.png";